import React from "react";
import { GlassCard } from "./ui";
import { btn3d } from "../styles/buttonStyles";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("페이지 렌더링 오류:", error, errorInfo);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  handleGoHome = () => {
    this.setState({ hasError: false });
    this.props.onGoHome?.();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const { dm = false } = this.props;
    return (
      <div className="animate-in">
        <GlassCard>
          <div role="alert" style={{ textAlign:"center", padding:"28px 12px" }}>
            <div className="text-2xl" style={{ marginBottom:12 }}>🧭</div>
            <h2 className="text-lg" style={{ color:"var(--accent)", fontWeight:900, marginBottom:8 }}>
              문제가 생겼어요
            </h2>
            <p className="text-sm" style={{ color:"var(--muted)", lineHeight:1.7, marginBottom:20 }}>
              이 화면을 표시하는 중 오류가 발생했습니다.<br />
              홈으로 돌아가 다시 시도해주세요.
            </p>
            <button
              type="button"
              onClick={this.handleGoHome}
              className="btn3d text-sm"
              style={{ ...btn3d("primary", dm), minHeight:46, padding:"11px 22px", borderRadius:13, fontWeight:800 }}
            >
              🏠 홈으로
            </button>
          </div>
        </GlassCard>
      </div>
    );
  }
}
